import * as theme from "../theme";

const UnauthorizedAccess = () => {
  return (
    <div
      style={{
        ...theme.fwfh,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          marginLeft: "12rem",
          marginRight: "12rem",
        }}
      >
        <div
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 35,
            color: theme.COLORS.primary_navyblue,
          }}
        >
          Accessing unauthorized link! Please make sure you are authorized to
          access this resource!
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedAccess;
